module.exports = __webpack_public_path__ + "static/ae4-b3691741481c4f3ab2f478cf1c2001cf.svg";